export const formatDateToCustomString = (dateString: string | null): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = date.toLocaleString('it-IT', { timeZone: 'Europe/Rome', day: 'numeric' });
  const month = date.toLocaleString('it-IT', { timeZone: 'Europe/Rome', month: 'long' });
  const time = date.toLocaleTimeString('it-IT', {
    timeZone: 'Europe/Rome',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return `${day} ${month} - ${time}`;
};
